import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyFeeForm } from 'src/app/classes/form-groups/company-fee-form';
import { Company } from 'src/app/classes/models';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-edit-company-fee-modal',
  templateUrl: './add-edit-company-fee-modal.component.html',
  styleUrl: './add-edit-company-fee-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditCompanyFeeModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @Input() CompanyFeeForm?: CompanyFeeForm;
  @Input() Company?: Company;

  feeTypes: string[] = ['BASE', 'RENEWAL', 'MULTICLIENT', 'PREFERRED'];

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  save() {
    if (!this.Company) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot Save. No company record found.',
        { returnError: true }
      );
    }

    if (!this.CompanyFeeForm) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot Save. No company fee form found.',
        { returnError: true }
      );
    }

    const errors = this.UtilityService.generateValidationErrorsObject(
      this.CompanyFeeForm
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot Save. There are errors in the form.',
        { returnError: true }
      );
    }

    Object.assign(this.Company, {
      CompanyFees: [this.CompanyFeeForm.getRawValue()]
    });

    this.activeModal.close();
  }

  ngOnInit(): void {
    if (!this.CompanyFeeForm) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No company fee form found.',
        { returnError: true }
      );
    }

    if (!this.Company) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No company record found.',
        { returnError: true }
      );
    }
  }
}
